module.exports = __webpack_public_path__ + "img/place-dxh.7f34255e.png";